module.exports = __webpack_public_path__ + "static/media/IMG_9815.e6783ebd.jpg";